module.exports = "/_next/static/images/6adb16af512c0c8ea948de087102f8ed-nuapp@2x.png";